import React from 'react';
import ModalOuterContainer from '../../generic/containers/ModalOuterContainer';
import Button from 'components/shared/generic/button/presentational/Button';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import Field from 'components/shared/form/presentational/Field';
import Select from 'components/shared/form/presentational/Select';
import useTranslate from 'lib/languages/useTranslate';
import { formatMoney } from 'lib/utils';
import { useSelector } from 'react-redux';
import { selectCardIsPosting } from 'lib/slices/cardsSlice';
import { useGetFeesQuery } from 'lib/services/fees';

interface Option {
    value: string;
    label: string;
}

interface StatusCardModalProps {
    handleSubmit: () => void;
    handleChange: (name: "status", value: string) => void;
    handleClose: () => void;
    status: string;
    options: Option[];
}

const StatusCardModal: React.FC<StatusCardModalProps> = ({
    handleSubmit,
    handleChange,
    handleClose,
    status,
    options,
}) => {
    const translate = useTranslate('cards.orderReplacementModal');
    const isPosting: boolean = useSelector(selectCardIsPosting);
    const { data: allFees } = useGetFeesQuery();

    return (
        <ModalOuterContainer customButtons={true}>
            <div className="description">
                <Typography tag="h1">{translate('titleText')}</Typography>
                <Typography styles={{ marginBottom: '8px' }}>
                    {translate('descriptionText')}
                </Typography>
                <Typography styles={{ marginBottom: '8px' }}>
                    {translate('feeWarning', {
                        fee: formatMoney(allFees?.replacementCard),
                    })}
                </Typography>
                <Typography>{translate('blockedWarning')}</Typography>
                <Field>
                    <Select
                        name="status"
                        value={status}
                        options={options}
                        onChange={handleChange}
                        placeholder={translate('placeholder')}
                    />
                </Field>
            </div>
            <div className="button-container">
                <Button
                    isPosting={isPosting}
                    disabled={isPosting}
                    className="cancel"
                    onClick={handleClose}
                >
                    {translate('cancel')}
                </Button>
                <Button
                    isPosting={isPosting}
                    disabled={isPosting}
                    onClick={handleSubmit}
                >
                    {translate('submitText')}
                </Button>
            </div>
        </ModalOuterContainer>
    );
};
export default StatusCardModal;
